import { render, staticRenderFns } from "./role-dialog.vue?vue&type=template&id=94a009e2"
import script from "./role-dialog.vue?vue&type=script&lang=js"
export * from "./role-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports